import request from '../utils/http'
// 异常申报列表
export function index (query) {
  return request({
    url: '/abnormal/index',
    method: 'GET',
    params: query
  })
}
// 审核
export function handle (query) {
  return request({
    url: '/abnormal/handle',
    method: 'POST',
    data: query
  })
}
// 开关
export function show (query) {
  return request({
    url: '/abnormal/show',
    method: 'POST',
    data: query
  })
}
// 详情
export function detail (query) {
  return request({
    url: '/abnormal/detail',
    method: 'GET',
    params: query
  })
}
// 导出
export function exportFn (query) {
  return request({
    url: '/abnormal/export',
    method: 'POST',
    data: query,
    responseType: 'blod'
  })
}



// WEBPACK FOOTER //
// ./src/api/abnormal.js